module.exports = __webpack_public_path__ + "img/en-2.7af59f28.png";